<template>
  <div class="page-dealers-application">
		<action-sidebar
		title="Aplicaciones"
		:value="true"
		:width="700"
		@close-modal="closeModal"
		>
		<v-tabs
		v-model="tabsModel"
		right
		slider-color="cyan"
		>
			<v-tab v-for="(item, index) in tabs" :key="index">
				{{ item.name }}
			</v-tab>
			<v-tabs-items>
				<v-tab-item>
					<v-flex xs9 text-xs-right px-3 py-3 mt-3>
						<v-select
							box
							label="Proyectos"
							background-color="white"
							hide-details
							:items="projectsAssigned"
							class="body-1"
							name="Proyectos"
							item-text="name"
							item-value="id"
							v-model="projectId"
							@change="listApplicationsAssigned(1)"
						></v-select>
					</v-flex>
					<v-flex xs12>
						<app-table
						:inputSearch="false"
						:filterColumns="false"
						class="mt-4 px-3"
						selectable
						name="application"
						:rows="listApplications"
						:check-all="checkAll"
						:columns="columns"
						:last-page="lastPage"
						:current-page="currentPage"
						:selected-value="selectedValue"
						@on-page="listApplicationsAssigned"
						@row-is-selected="rowIsSelected"
						@on-selected-all="allSelected"
						>
							<template slot="rows" slot-scope="props">
								<td class="is-not-selectable" v-show="showRow(columns, 1)">
									{{ props.row.name}}
								</td>
								<td v-show="showRow(columns, 2)">
									{{ props.row.repo }}
								</td>
								<td v-show="showRow(columns, 3)">
									{{ props.row.codeApp }}
								</td>
								<td v-show="showRow(columns, 4)">
									{{ props.row.project.data.name }}
								</td>
							</template>
						</app-table>
					</v-flex>
				</v-tab-item>
				<v-tab-item>
					<v-flex xs9 mt-4>
						<v-select
							box
							label="Proyectos"
							background-color="white"
							hide-details
							:items="projectsDeallocated"
							class="body-1 px-3"
							name="Proyectos"
							item-text="name"
							item-value="id"
							v-model="projectIdDeallocated"
							@change="listApplicationsDeallocated(1)"
						></v-select>
					</v-flex>
					<v-flex xs12>
						<app-table
						:inputSearch="false"
						:filterColumns="false"
						:rows="listDeallocated"
						:columns="columns"
						:last-page="lastPageDeallocated"
						:current-page="currentPageDeallocated"
						:selected-value="selectedValueDeallocated"
						:check-all="checkAllDeallocated"
						selectable
						class="px-3 mt-4"
						@on-page="listApplicationsDeallocated"
						@row-is-selected="rowIsSelectedDeallocated"
						@on-selected-all="allSelectedDeallocated">
						<template slot="rows" slot-scope="props">
							<td class="is-not-selectable" v-show="showRow(columns, 1)">
								{{ props.row.name }}
							</td>
							<td v-show="showRow(columns, 2)">
								{{ props.row.repo }}
							</td>
							<td v-show="showRow(columns, 3)">
								{{ props.row.codeApp }}
							</td>
							<td v-show="showRow(columns, 4)">
								{{ props.row.project.data.name }}
							</td>
						</template>
						</app-table>
					</v-flex>
				</v-tab-item>
			</v-tabs-items>
		</v-tabs>
		<section class="modal-filter-footer pt-4 pb-4 center-buttons">
			<v-btn
			color="pink"
			class="btn-action"
			@click="closeModal"
			>Cancelar</v-btn>
			<v-btn class="btn-action ml-2"
			color="success"
			:disabled="disabledAssigned(1)"
			@click="assignedApplications"
			>
				Asignar
			</v-btn>
			<v-btn
			color="success" 
			class="btn-action ml-2"
			:disabled="disabledDeallocate(0)"
			@click="deallocatedApplications">
				Deasignar
			</v-btn>
		</section>
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';

function created() {
	this.listProjectAssigned();
	this.listProjectDeallocated();
	this.listApplicationsAssigned();
	this.listApplicationsDeallocated();
}

async function deallocatedApplications() {
	const ids = this.dataSelectedDeallocated.map(l => l.id);
	const body = {
		appsIds: ids,
	};
	try {
		await this.$http.delete(`distributaries/${this.id}/apps`, { data: body });
		this.showNotification('Las aplciaciones fueron desasignadas correctamente.');
		this.listApplicationsDeallocated();
		this.closeModal();
	} catch (error) {
		this.showError();
	}
}

async function assignedApplications() {
	const appsIds = this.dataSelected.map(p => p.id);
	try {
		await this.$http.post(`distributaries/${this.id}/apps`, { appsIds });
		this.showNotification('Las aplicaciones fueron asignadas correctamente');
		this.listApplicationsAssigned();
		this.closeModal();
	} catch (error) {
		this.showError();
	}
}

function rowIsSelected(row) {
	this.listApplications = this.selectIsRow(this.listApplications, this.selectedValue, row);
	this.checkAll = this.every(this.listApplications, this.selectedValue);
	this.dataSelected = this.listApplications.filter(r => r.selectedAssigned);
}

function rowIsSelectedDeallocated(row) {
	this.listDeallocated = this.selectIsRow(this.listDeallocated, this.selectedValueDeallocated, row);
	this.checkAllDeallocated =
	this.every(this.listDeallocated, this.selectedValueDeallocated);
	this.dataSelectedDeallocated = this.listDeallocated.filter(r => r.flag);
}

function allSelectedDeallocated(checked) {
	this.checkAllDeallocated = checked;
	this.dataSelectedDeallocated = [];
	this.listDeallocated = this.listDeallocated.map((element) => {
		const newDeallocated = { ...element };
		newDeallocated.isSelected = checked;
		if (checked) {
			this.dataSelectedDeallocated.push(element);
		}
		return newDeallocated;
	});
	this.rowsDealllistDeallocatedocated =
	this.selectIsRow(this.listDeallocated, this.selectedValueDeallocated, false, checked);
}

function allSelected(checked) {
	this.checkAll = checked;
	this.dataSelected = [];
	this.listApplications = this.listApplications.map((element) => {
		const newApplications = { ...element };
		newApplications.isSelected = checked;
		if (checked) {
			this.dataSelected.push(element);
		}
		return newApplications;
	});
	this.listApplications =
	this.selectIsRow(this.listApplications, this.selectedValue, false, checked);
}

async function listApplicationsAssigned(page = 1) {
	this.currentPage = page;
	this.params.page = this.currentPage;
	const params = {
		projectId: this.projectId,
		isSelected: 0,
		page: this.params.page,
		perPage: 30,
	};
	try {
		const response = await this.$http.get(`distributaries/${this.id}/apps`, { params });
		this.listApplications = response.data.data;
		this.lastPage = Number(response.headers['x-last-page']);
	} catch (error) {
		if (error.status === 500) {
			this.showError();
		}
	}
}

async function listApplicationsDeallocated(page = 1) {
	this.currentPageDeallocated = page;
	this.params.page = this.currentPageDeallocated;
	const paramsDeallocated = {
		projectId: this.projectIdDeallocated,
		isSelected: 1,
		page: this.params.page,
		perPage: 30,
	};
	try {
		const response = await this.$http.get(`distributaries/${this.id}/apps`, { params: paramsDeallocated });
		this.listDeallocated = response.data.data;
		this.lastPageDeallocated = Number(response.headers['x-last-page']);
	} catch (error) {
		if (error.status === 500) {
			this.showError();
		}
	}
}

function disabledAssigned(value) {
	return this.tabsModel === value || this.dataSelected.length < 1;
}

function disabledDeallocate(value) {
	return this.tabsModel === value || this.dataSelectedDeallocated.length < 1;
}

async function listProjectAssigned() {
	const params = {
		isSelected: 1,
		page: 1,
		perPage: 30,
	};
	try {
		const response = await this.$http.get(`distributaries/${this.id}/projects`, { params });
		this.projectsAssigned = response.data.data;
	} catch (error) {
		if (error.status === 500) {
			this.showError();
		}
	}
}

async function listProjectDeallocated() {
	const params = {
		isSelected: 1,
		page: 1,
	};
	try {
		const response = await this.$http.get(`distributaries/${this.id}/projects`, { params });
		this.projectsDeallocated = response.data.data;
	} catch (error) {
		if (error.status === 500) {
			this.showError();
		}
	}
}

function closeModal() {
	this.goTo('page-config-dealers');
}

function data() {
	return {
		dataSelected: [],
		dataSelectedDeallocated: [],
		checkAllDeallocated: false,
		checkAll: false,
		columns: [
			{ id: 1, name: 'Nombre', value: 'name', checked: true, visible: true },
			{ id: 2, name: 'Repositorio', value: 'repository', checked: true, visible: true },
			{ id: 3, name: 'Cod. App', value: 'codeApp', checked: true, visible: true },
			{ id: 4, name: 'Proyecto', value: 'project', checked: true, visible: true },
		],
		currentPageDeallocated: 1,
		currentPage: 1,
		listDeallocated: [],
		lastPage: 0,
		lastPageDeallocated: 0,
		listApplications: [],
		projectsAssigned: [],
		projectsDeallocated: [],
		projectIdDeallocated: '',
		projectId: '',
		selectedValue: 'selectedAssigned',
		selectedValueDeallocated: 'flag',
		rowsDeallocated: [],
		tabsModel: null,
		tabs: [
			{
				id: 1,
				name: 'Asignar',
			},
			{
				id: 2,
				name: 'Asignados',
			},
		],
	};
}

export default {
	name: 'page-dealers-application',
	created,
	data,
	components: {
		actionSidebar,
	},
	methods: {
		allSelected,
		allSelectedDeallocated,
		assignedApplications,
		closeModal,
		deallocatedApplications,
		disabledAssigned,
		disabledDeallocate,
		listApplicationsAssigned,
		listApplicationsDeallocated,
		listProjectAssigned,
		listProjectDeallocated,
		rowIsSelected,
		rowIsSelectedDeallocated,
	},
	props: {
		id: {
			type: [Number, String],
		},
	},
};
</script>

<style lang="scss">
.center-buttons {
	align-items: center;
	display: flex;
	justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/configuration/page-dealers-application.vue